import QueuedOrders from "../symbols/queuedOrders";

interface State {
  data: OrderResponseModel;
  loading: boolean;
  error: any;
}
const initialState: State = {
  data: { TotalCount: 0, ShopDeliveries: [], Deliveries: [] },
  loading: false,
  error: false,
};
export interface OrderResponseModel {
  TotalCount: number;
  ShopDeliveries: IShopDeliveries[];
  Deliveries: Array<any>;
}
export interface IShopDeliveries {
  Deliveries: Array<any>;
  ShopName: string;
  TotalCountByShop: number;
}

export default function QueuedOrdersReducer(state = initialState, action: any) {
  switch (action.type) {
    case QueuedOrders.QUEUED_ORDERS:
      return { ...state, loading: true, error: false };
    case QueuedOrders.QUEUED_ORDERS_SUCCESS:
      if (state.data.TotalCount === 0) {
        return {
          ...state,
          data: action.payload.Result,
          loading: false,
          error: false,
        };
      } else {
        let temp = state.data;
        temp.Deliveries = [
          ...temp.Deliveries,
          ...action.payload.Result.Deliveries,
        ];

        return {
          ...state,
          data: temp,
          loading: false,
          error: false,
        };
      }

    case QueuedOrders.QUEUED_ORDERS_FAILURE:
      return {
        ...state,
        data: initialState.data,
        loading: false,
        error: true,
      };
    case QueuedOrders.CLEAR_QUEUED_ORDERS:
      return {
        ...state,
        data: initialState.data,
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
